import { ShopperAgentSandboxMessageSchema } from "@redotech/redo-shopper-agent-common/sandbox/sandbox-message";
import { TriggerKeySchema } from "@redotech/redo-shopper-agent-common/trigger-definition";
import * as z from "zod";

export const generateSandboxTrigger = {
  name: "generateSandboxTrigger" as const,
  input: z
    .object({
      threadId: z.string().nullable(),
      customerId: z.string(),
      triggerKey: TriggerKeySchema,
    })
    .strict(),
  output: z.object({
    threadId: z.string(),
    messages: z.array(ShopperAgentSandboxMessageSchema),
  }),
};
